import React from "react";
import { styled } from "../../../../stitches.config";

import Heading from "../../../../redesign/atoms/Heading";
import CompletedProject from "./CompletedProject";
import { useWindowWidth } from "../../../../helpers/useWindowWidth";

type Author = {
  img: string;
  name: string;
};
type Picture = {
  alt?: string;
  figcaption?: string;
  img: string;
  source?: string;
  title?: string;
};
type BridProgress = {
  amount: number;
  endDate: string;
  endDate_text?: string;
  reqAmount: number;
};

export interface ICompletedProject {
  title: string;
  url: string;
  picture: Picture;
  author: Author;
  brid_donation_progress: BridProgress;
  finished?: boolean;
  timeLeft?: string;
  amount: number;
  reqAmount: number;
  isDarkMode: boolean;
}

type TProjects = {
  projects: Array<ICompletedProject>;
};
//@TODO dokończyć desktop i dodać linki

const BridCompletedProjects: React.FC<{ blockData: Array<ICompletedProject> }> =
  ({ blockData }) => {
    const width: number = useWindowWidth();
    const isDesktop = window.innerWidth >= 996;

    return (
      <Wrap className={isDesktop ? 'container' : ''}>
        <HeadingWrap>
          <Heading
            title={
              width < 768
                ? "Zrealizowane projekty"
                : "Sprawdź zrealizowane projekty"
            }
            specialHeadingStyle="specialDots"
            specialHeading
          />
        </HeadingWrap>

        <CompletedProjects>
          {blockData.map((item, index) => (
            <CompletedProject key={index} {...item} />
          ))}
        </CompletedProjects>
      </Wrap>
    );
  };

const Wrap = styled("div", {
  marginTop: "20px",
  position: "relative",
  "@media (min-width: 992px)": {
    zIndex: 3
  }
});

const HeadingWrap = styled("div", {
  padding: "0 12px",
  "@bp4": {
    padding: "0 32px"
  }
});

const CompletedProjects = styled("div",{
  overflow: "auto",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: "0 12px",
  "@media (min-width: 992px)": {
    marginTop: "20px",
    justifyContent: "space-around",
    whiteSpace: "normal"
  }
  /* white-space: nowrap; */
  /* margin-top: 15px; */
});

export default BridCompletedProjects;
